import breakpoints from "./breakpoints";
import functional from "./functional";
import mixins from "./mixins";
import palette from "./palette";
import { radii, shadows, spacing, tapTarget, typography, zIndex } from "./tokens";

const theme = {
  ...functional,
  ...breakpoints,
  mixins,
  palette,
  spacing,
  typography,
  radii,
  shadows,
  zIndex,
  tapTarget,
};

export default theme;
